import { createAsyncThunk } from '@reduxjs/toolkit';
import { ShiftWizardApi, GetAvailableShiftsResponse } from 'api/ShiftWizardApi';

import { ErrorResponse } from './ErrorResponse';

export const createGetAvailableShiftsThunk = (api: ShiftWizardApi) =>
  createAsyncThunk('shiftWizard/getAvailableShifts', async (appId: string, thunkApi) => {
    try {
      const response: GetAvailableShiftsResponse = await api.getAvailableShifts(appId);
      return response;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
    }
  });
